// extracted by mini-css-extract-plugin
export default {"b-icon-warning":"CaptureVisa_style_b-icon-warning__P3b5t","wrapper":"CaptureVisa_style_wrapper__2RJ9-","rotate":"CaptureVisa_style_rotate__0BT1G"};